import { Theme } from '@/theme';
import type { HSL } from '@/utils/common';
import styled, { css } from 'styled-components';

type ColorPickerContainerAttributes = {
  popup?: boolean;
};

export const ColorPickerContainer = styled.div(
  ({ popup }: ColorPickerContainerAttributes) => css`
    margin: 16px 0px 0px;
    position: relative;
    display: block;

    height: 96px;
    width: 100%;

    label {
      font-size: ${Theme.rems(16)};
      color: ${Theme.color.text};

      margin-bottom: 2px;
      line-height: 140%;
    }

    ${popup &&
    css`
      margin-bottom: 0px;
      height: 112px;
    `}
  `
);

export const PickerContainer = styled.div`
  flex-direction: column;
  display: flex;
  gap: 18px;
`;

const BaseBar = styled.div`
  border-radius: 8px;
  position: relative;

  height: 16px;
  width: 100%;
`;

export const HueBar = styled(BaseBar)`
  background-image: linear-gradient(
    90deg,
    red 0,
    #ff0 17%,
    #0f0 33%,
    #0ff 50%,
    #00f 67%,
    #f0f 83%,
    red
  );
`;

type BarAttributes = {
  hsl: HSL;
};

export const SaturationBar = styled(BaseBar)(
  ({ hsl }: BarAttributes) => css`
    background-image: linear-gradient(
      90deg,
      hsl(${hsl.h}, 0%, 50%),
      hsl(${hsl.h}, 20%, 50%),
      hsl(${hsl.h}, 40%, 50%),
      hsl(${hsl.h}, 60%, 50%),
      hsl(${hsl.h}, 80%, 50%),
      hsl(${hsl.h}, 100%, 50%)
    );
  `
);

export const LightnessBar = styled(BaseBar)(
  ({ hsl }: BarAttributes) => css`
    background-image: linear-gradient(
      90deg,
      hsl(${hsl.h}, 100%, 0%),
      hsl(${hsl.h}, 100%, 20%),
      hsl(${hsl.h}, 100%, 40%),
      hsl(${hsl.h}, 100%, 60%),
      hsl(${hsl.h}, 100%, 80%),
      hsl(${hsl.h}, 100%, 100%)
    );
  `
);

type PointerAttributes = {
  left: number;
};

export const Pointer = styled.div(
  ({ left }: PointerAttributes) => css`
    background-color: rgb(255 255 255);
    transform: translate(-12px, -5px);

    border: 1px solid #000;
    pointer-events: none;
    left: ${left * 100}%;

    border-radius: 50%;
    position: absolute;

    height: 26px;
    width: 26px;
  `
);
